export const data = new Object({
	fieldModel:{
		"fieldId":null,
		// "sectionId":null, 
		// "sectionName":null, 
		"name":null,
		"listName":null,
		"accountGroupId":null, 
		"accountGroupName":null, 
		// "displayName":null,
	 	// "fieldType":{"title":"Text", "value":'text'},
	 	"fieldType":"text", 
	 	"listId":null,
	 	"additionalDataObject":{
	 		"maxLength":null, 
		 	// "uniqueMode":0, 
		 	"choiceText":null,
		 	"choices":[], 
		 	"defaultChoice":null,
		 	"defaultValue":false, 
		 	"codeMode":1, 
		 	"codeLength":null, 
		 	"prefix":null, 
		 	"nextCode":null, 
		 	"suffix":null, 
		 	// "listId":null, 
		 	// "listName":null,
		 	"listMultiple": false,
		 	"groupId":null,
		 	"groupName":null,
		 	"groupMultiple":false,
		 	// "accountGroupId":null, 
		 	// "accountGroupName":null, 
	 	},
	 	"additionalData":null,
	 	"isRequired":false,
	 	"isSystem":0,
	 	"groupTypeId":101,
	 	"draftItems":[],
	 	"isNew":true
	 },

	 fieldData:{
	 	"fieldId":null,
	 	"name":null,
		"displayName":null,
		"sectionId":null, 
		"sectionName":null, 
	 	"fieldType":null,
	 	"isRequired":false
	 	// "deletedFieldIds":[]
	 }
})


// WEBPACK FOOTER //
// ./src/components/fields/datamodel.js